import React from "react";

// PlaylistEmbed: lightweight wrapper to render a safe Spotify (or other) iframe
// Usage: <PlaylistEmbed src="https://open.spotify.com/embed/..." />
export default function PlaylistEmbed({
  src = "https://open.spotify.com/embed/playlist/7hewMfTuizWfSNdSg6MQR3?utm_source=generator",
  width = "100%",
  height = 352,
  borderRadius = 12,
  title = "Playlist embed",
  testId = "embed-iframe",
  allow = "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
  loading = "lazy",
}) {
  const style = { borderRadius: borderRadius + "px", border: "none" };
  return (
    <iframe
      data-testid={testId}
      title={title}
      src={src}
      style={style}
      width={width}
      height={height}
      frameBorder="0"
      allow={allow}
      // React uses camelCase for allowFullScreen
      allowFullScreen
      loading={loading}
    />
  );
}
